import { Fragment, CSSProperties, ReactNode } from 'react'

import { LogoTop } from '~/components/LogoTop'
import { Footer } from '~/components/Footer'

export default function MathVaultClearLayout({
  children,
  headerClassName = '',
  leftAddon,
  rightAddon,
  style,
}: {
  children: React.ReactElement
  headerClassName?: string
  leftAddon?: ReactNode
  rightAddon?: ReactNode
  style?: CSSProperties
}): React.ReactElement {
  return (
    <Fragment>
      <div className="box-content min-h-full">
        <LogoTop
          className={headerClassName}
          isLogoH1
          leftAddon={leftAddon}
          rightAddon={rightAddon}
          showOnLargeScreen
          style={style}
        />

        {children}
      </div>
      <Footer />
    </Fragment>
  )
}
